import React, { useRef } from 'react';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import proptypes from 'prop-types';

const { string, bool, number } = proptypes;

const CLASS_NAME = 'sui-object-cover sui-w-full sui-aspect-video';

const VideoPlayerWrap = ({
  videoUrl = '',
  videoStill = null,
  componentId,
  componentPosition = 1,
  enableB2CRadius = false
}) => {
  const isYoutubeVideo = /youtu(be\.com|\.be)/i.test(videoUrl);

  const videoSrcs = {
    videoId: undefined,
    videoSrc: undefined
  };

  if (isYoutubeVideo) {
    const id = (videoUrl.match(/[a-z0-9\-_]{10,}/i) || [''])[0];
    videoSrcs.videoSrc = `https://www.youtube.com/embed/${id}`;

  } else {
    videoSrcs.videoId = (videoUrl.match(/video\/[0-9]{1,}/i) || [''])[0].replace(/video\//i, '');
  }

  // componentId + componentPosition + videoSrc can collide when the same
  // Contentful entry/position renders more than once on a page (e.g. reused
  // across containers), so a stable per-mount suffix keeps each key unique.
  const uniqueSuffixRef = useRef(Math.random().toString(36).slice(2, 8));

  const videoSrcOrId = videoSrcs.videoSrc || videoSrcs.videoId;
  const playerKey = `${componentId}-${componentPosition}-${videoSrcOrId}-${uniqueSuffixRef.current}`;

  return (
    <div
      className={CLASS_NAME}
      data-contentful-entry-id={componentId}
      data-contentful-field-id="video"
    >
      <VideoPlayer
        key={playerKey}
        playerId={playerKey}
        className={CLASS_NAME}
        videoId={videoSrcs.videoId}
        videoSrc={videoSrcs.videoSrc}
        videoStill={videoStill}
        aspectRatio={16 / 9}
        shouldUseContentPlayer
        enableB2CRadius={enableB2CRadius}
      />
    </div>
  );
};

VideoPlayerWrap.propTypes = {
  videoUrl: string,
  videoStill: string,
  componentId: string.isRequired,
  componentPosition: number,
  enableB2CRadius: bool
};

export { VideoPlayerWrap };